import * as React from 'react';
import { TNavigationPanel } from './NavigationPanel.types';
import { ADMIN_PANEL_CONFIG } from 'screens/AdminPanel/config';
import { Accordion, AccordionDetails, AccordionSummary } from 'components';
import { ExpandMore } from '@mui/icons-material';
import './NavigationPanel.styles.scss';
import { hasSelectedChild } from './utils';

export const NavigationPanel: TNavigationPanel = ({
  selectedPanelItemId,
  setSelectedPanelItem,
}) => {
  return (
    <>
      {ADMIN_PANEL_CONFIG.map((adminPanelConfigItem) => (
        <div key={adminPanelConfigItem.id}>
          <Accordion
            slotProps={{ heading: { component: 'h4' } }}
            key={adminPanelConfigItem.id}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content"
              id="panel1-header"
              disableRipple={hasSelectedChild(
                selectedPanelItemId,
                adminPanelConfigItem.children
              )}
            >
              <p className="body2">{adminPanelConfigItem.displayName}</p>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                {adminPanelConfigItem.children.map((panelConfigChild) => (
                  <div
                    key={panelConfigChild.id}
                    className={`navigation-panel__navigation-child ${
                      selectedPanelItemId === panelConfigChild.id
                        ? 'navigation-panel__navigation-child--selected'
                        : ''
                    }`}
                    onClick={() => setSelectedPanelItem(panelConfigChild.id)}
                  >
                    {panelConfigChild.displayName}
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </>
  );
};
